var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.88 19.052a8.88 8.88 0 1 0 0-17.76 8.88 8.88 0 0 0 0 17.76ZM16.43 16.723l6.984 6.984",
  stroke: "#7A7A7A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgSearch as ReactComponent };
export default __webpack_public_path__ + "/assets/49d321e3cd56ae682207fbb7342b4154.svg";